<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>

    <ion-content>
      <div class="flow-content">
        <TestResultTips :data="result" :number="user_info.number">
          <template #before-number>
            <ConfirmButton class="flow-confirm-button" text="明白" position="relative" @click="goNextPage"></ConfirmButton>
          </template>
        </TestResultTips>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import TestResultTips from "../components/test/TestResultTips";
import Background from "../components/common/Background";
import ConfirmButton from "../components/common/ConfirmButton";
import WhiteBackground from "../components/common/WhiteBackground";
import common from "../common";
import router from "../router";

export default {
  name: "TestResult",
  components: {
    WhiteBackground,
    ConfirmButton,
    Background,
    TestResultTips,
    IonPage,
    IonContent
  },
  data() {
    return {
      user_info: {},
      result: [],
      is_pass: false,
      audio: null,
      play_timeout: null,
    }
  },
  ionViewWillEnter() {
    common.getUserInfo().then(user_info => {
      this.user_info = user_info;

      common.getStorage('result_'+this.user_info.id).then(res => {
        this.result = res;
        if (res.advice_type == '合格') {
          this.is_pass = true;
        }

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        this.play_timeout = setTimeout(function () {
          const voice_id = that.is_pass ? 19 : 18;
          that.audio = new Audio(common.getVoice(voice_id));
          that.audio.play();
        }, 2000);
      })
    })

  },
  ionViewWillLeave(){
    if (this.audio) {
      this.audio.pause();
    }
    if (this.play_timeout) {
      clearTimeout(this.play_timeout)
    }
  },
  methods: {
    goNextPage: function () {
      if (this.is_pass) {
        router.replace('/surveyPrepare/pass');
      } else {
        router.replace('/FollowUp');
      }

    }
  }
}
</script>

<style scoped>
.flow-confirm-button :deep(.relative) {
  margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
}
</style>
